import { Api } from "@/models/class/api.class";
import { Pagination } from "@/models/constant/interface/common.interface";
import {
  ErrorResponseModel,
  RequestQueryParamsModel,
} from "@/models/interface/http.interface";
import { InvoiceIcBillingOverdueResponseDto } from "@/models/interface/invoice-overdue";
import { AxiosError } from "axios";
import { HttpClient } from "./HttpClient.service";

export class InvoiceOverdueService extends HttpClient {
  getInvoiceOverdue(
    params: RequestQueryParamsModel
  ): Promise<Pagination<InvoiceIcBillingOverdueResponseDto>> {
    return this.get<Pagination<InvoiceIcBillingOverdueResponseDto>>(
      Api.InvoiceOverdue,
      { params }
    )
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }

  getInvoiceOverdueDownload(params: RequestQueryParamsModel): Promise<Blob> {
    return this.get<Blob>(Api.InvoiceOverdue + "/download", {
      params,
      responseType: "blob",
    })
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }
}

export const invoiceOverdueService = new InvoiceOverdueService();
